import React from "react";
import ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

// <reference path="stubs.env.d.ts"/>
import * as env from "env";

Sentry.init({
  dsn: "https://c4eb290372ee4b37b37c9ed535db138f@o157672.ingest.sentry.io/6379683",
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

Sentry.setContext("Build", {
  commit: env.AWS_COMMIT_ID || "No Commit Information",
});

ReactDOM.render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>,
  document.getElementById("app")
);
